import { distinctUntilChanged } from 'rxjs';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import type { CheckboxChangeEvent } from 'primeng/checkbox';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-form-control-input-checkbox',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './checkbox.input.form-control.design.html',
    styleUrls: ['./checkbox.input.form-control.design.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class CheckboxInputFormControlDesign implements OnInit, OnChanges {
  @Input() formField = true;
  @Input({ required: true }) control!: AbstractControl;
  @Input() inputClass?: string;
  @Input() label?: string;
  @Input() inputGroup = false;
  @Input() disabled = false;
  @Input() labelTop = false;
  @Input() trueValue = true;
  @Input() falseValue = false;
  @Output() valueChange = new EventEmitter<CheckboxChangeEvent>();
  
  name?: string;

  constructor(private cd: ChangeDetectorRef, private destroyRef: DestroyRef) {
  }

  ngOnInit() {
    const formGroup = this.control.parent;
    if (!formGroup) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_group_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.CheckboxInputFormControlDesign.ngOnInit"
      );
    }
    this.name = Object.keys(formGroup.controls).find(name => this.control === formGroup.get(name)) ?? undefined;
    if (this.name === undefined) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_control_name_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.CheckboxInputFormControlDesign.ngOnInit"
      );
    }

    this.control?.statusChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged()).subscribe(() => {
      this.cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }
}
